// useForm.js

import { useState, useEffect } from 'react';
import { downloadFiles, getCustomerLeadgerData, getDivisionWiseOutstandingNew, fetchProfitCenters } from '../../Service/ApiService';
import { showSuccessAlert } from 'utils/SuccessMessage';
// const DivisionWiseOutstandingControllerNew = (initialState, validate) => {
const DivisionWiseOutstandingController = (initialState) => {
  const [formData, setFormData] = useState(initialState);
  const [customeroptions, setCustomerOptions] = useState([]);
  const [divoutdata, setdivoutdata] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const user = JSON.parse(localStorage.getItem('user'));
  const [searchText, setSearchText] = useState('');
  const [totalAmount, setTotalAmount] = useState(0);
  const [profitCenters, setProfitCenters] = useState([]);
  const [selectedProfitCenter, setSelectedProfitCenter] = useState('');
      const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  // const [profitCentersParam, setProfitCentersParam] = useState('');

  useEffect(() => {
    if (user.profitCenter != null) {
      getProfitCenters(user.profitCenter);
    }
  }, []);

  // Close loading when data completely rendered
  useEffect(() => {
    if (cloading) {  // Remove the !cloading check
      setcLoading(false);
    }
  }, [divoutdata]);

  useEffect(() => {
    getCustomer();
  }, [searchText]);

  useEffect(() => {
    if (user.userVerticalId == "Garment") {
      fetchDivOutStandingData(user.userCode);
    }
  }, []);

  useEffect(() => {
    // if (formData.customer != null || formData.customer != '') {
    if (formData.customer == null || formData.customer == '') {
      fetchDivOutStandingData(user.userCode);
    }
    else {
      fetchDivOutStandingData(formData.customer.value);
    }
  }, [formData.customer, selectedProfitCenter]);

  useEffect(() => {
    if (!Array.isArray(divoutdata)) return;

    // const amount = divoutdata.reduce((sum, item) => {
    //   const match = item.balance?.match(/(Cr|Dr)\.(\d+(\.\d+)?)/);
    //   if (match) {
    //     const sign = match[1] === 'Cr' ? 1 : -1;
    //     const value = parseFloat(match[2]);
    //     return sum + sign * value;
    //   }
    //   return sum;
    // }, 0);

    // setTotalAmount(amount.toFixed(2));
  }, [divoutdata]);

  // Fetch Profit centers
  const getProfitCenters = async (profitCentersParam) => {
    try {
      setcLoading(true);
      const response = await fetchProfitCenters(profitCentersParam);
      // console.log(response);

      // setLedgerData([]); // Clear previous ledger data
      if (response && response.success) {

        // Map API response into { value, label } format for react-select
        const mappedProfitCenters = response.data.map(item => ({
          value: item.profitCenter,
          label: `${item.profitCenterName} - ${item.profitCenter}`
        }));
        // console.log(mappedProfitCenters);
        setProfitCenters(mappedProfitCenters);

        // const allProfitCentersValues = mappedProfitCenters.map(item => item.value).join(',');
        setSelectedProfitCenter(mappedProfitCenters[0])
        // setProfitCentersParam(mappedProfitCenters[0].value);

       // fetchLedgerData(user.userCode, confvalue.confvertical, mappedProfitCenters[0].value);
        // If only one profit center, auto-select it
        // if (mappedProfitCenters.length === 1) {
        //   setSelectedProfitCenter(mappedProfitCenters[0]);
        //   setProfitCentersParam(mappedProfitCenters[0]);
        // }
      }

      setcLoading(false);
    } catch (error) {
      console.error('Error fetching profit centers:', error);
      setcLoading(false);
    }
  };

  // Handle Prodfit center filter change
  const handleProfitCenterChange = (value) => {
    if (value) {
      setFormData({
        ...formData,
        ['profitCenters']: value // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['profitCenters']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['profitCenters']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['profitCenters']: '' // You can set a validation error or reset it
      });

      //setLedgerData([]);
    }
    setSelectedProfitCenter(value);
    // setProfitCentersParam(value ? value.value : '');
    // fetchLedgerData(formData.customer.value ?? user.userCode, confvalue.confvertical ?? "", value.value)
  }

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const handleViewClick = (rowData) => {
    console.log(rowData);
  };

  const getCustomer = async () => {
    try {
      setcLoading(true);
      const response = await getCustomerLeadgerData(user.userCode, searchText);
      if (response && response.success === 'true') {
        setCustomerOptions([]);

        const uniqueCustomerOptions = response.customerList.reduce((uniqueList, currentItem) => {
          // Check if the partyCode of the current item is already present in the unique list
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString()
            });
          }

          return uniqueList;
        }, []);
        setCustomerOptions(uniqueCustomerOptions);
      }
      // setcLoading(false);
    } catch (error) {
      setcLoading(false);
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const validationErrors = validate(formData);
  //   setErrors(validationErrors);

  //   if (Object.keys(validationErrors).length === 0) {
  //     fetchDivOutStandingData(formData.customer.value); // Use the new function
  //   }
  // };

  const handleDownloadClick = async (e) => {
    e.preventDefault();
    // const validationErrors = validate(formData);
    // setErrors(validationErrors);

    //if (Object.keys(validationErrors).length === 0) {
    setcLoading(true);
    let param = '';

    if (user.userVerticalId == "Garment") {
      param = `partyCode=${formData.customer.value || user.userCode}&profitCenter=${user.profitCenter}&userVertical=${confvalue.confvertical}&isSFA=${user.isSFA}`;
    }
    else {
      param = `partyCode=${formData.customer.value || user.userCode}&profitCenter=${selectedProfitCenter.value}&userVertical=${confvalue.confvertical}&isSFA=${user.isSFA}`;
    }
    // const param = `partyCode=${formData.customer.value || user.userCode}&profitCenter=${user.profitCenter}&isSFA=${user.isSFA}`;
    // const param = `partyCode=${formData.customer.value || user.userCode}&profitCenter=${profitCentersParam}&isSFA=${user.isSFA}`;
    const response = await downloadFiles(param, 'divisionWiseOutStandingDownload.php', 'divout.xls');
    if (response == true) {
      showSuccessAlert('File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
    //  }
  };

  const fetchDivOutStandingData = async (customerCode) => {
    try {
      setcLoading(true);

      let profitCenter = '';
      if (user.userVerticalId == 'Garment') {
        profitCenter = user.profitCenter;
      }
      else {
        profitCenter = selectedProfitCenter.value;
      }

      // const response = await getDivisionWiseOutstandingNew(customerCode, user.profitCenter, user.isSFA);
      const response = await getDivisionWiseOutstandingNew(customerCode, profitCenter,confvalue.confvertical, user.isSFA);

      setdivoutdata([]);
      if (response && response.success === 'true') {
        setdivoutdata(response.data.transactions);
        setTotalAmount(response.data.grandTotal);
      } else {
        setdivoutdata([]);
        setTotalAmount(0);
      }
      // setcLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setcLoading(false);
      setTotalAmount(0);
    }
  };

  const handleCustomerChange = (e) => {
    localStorage.setItem('SelectedLedgerCustomer', JSON.stringify(e));
    if (e) {
      setFormData({
        ...formData,
        ['customer']: e // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['customer']: '' // Clear any existing errors
      });
      setdivoutdata([]);
      fetchDivOutStandingData(e.value);
    } else {
      // When selection is cleared
      // const defaultCustomer = {
      //   value: user.userCode,
      //   label: user.userName || user.userCode, // optional if you have userName
      // };

      setFormData({
        ...formData,
        ['customer']: user.userCode // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['customer']: '' // You can set a validation error or reset it
      });

      setdivoutdata([]);
    }
  };

  return {
    profitCenters,
    selectedProfitCenter,
    divoutdata,
    totalAmount,
    formData,
    user,
    cloading,
    errors,
    customeroptions,
    handleCustomerChange,
    // handleSubmit,
    handleInputChange,
    handleViewClick,
    handleDownloadClick,
    handleProfitCenterChange
  };
};

export default DivisionWiseOutstandingController;
